function CatalogCtrl() {
  var ctrl = this;
  ctrl.getFilterDataRender = function (isRender) {
    this.isFilterRender = isRender;
  };
  ctrl.normalize_count = (number, words_arr) => {
    number = Math.abs(number);
    if (Number.isInteger(number)) {
      let options = [2, 0, 1, 1, 1, 2];
      return words_arr[number % 100 > 4 && number % 100 < 20 ? 2 : options[number % 10 < 5 ? number % 10 : 5]];
    }
    return words_arr[1];
  };
  ctrl.carouselInit = carousel => {
    let indexActive = carousel.options.indexActive;
    if (indexActive > 0) {
      carousel.goto(indexActive - 1, false);
    }
  };
}
export default CatalogCtrl;